import { ColumnDefinition, Grid, Table, Text } from '@approvalmax/ui/src/components';
import { intl } from '@approvalmax/utils';
import moment from 'moment';
import { TransactionKind } from 'shared/data/wallets/v1';
import { getCountryFlagByCountryCode } from 'shared/helpers';

import { getCountryCodeByCurrency } from '../../Wallets.helpers';
import { TransactionStatusTag } from '../TransactionStatusTag/TransactionStatusTag';
import { getTransactionTypeText } from './TransactionsList.helpers';
import { messages } from './TransactionsList.messages';
import { ColumnId, Transaction, TransactionSort } from './TransactionsList.types';

export const getColumns = (sort: TransactionSort): ColumnDefinition<Transaction>[] => [
    {
        id: ColumnId.Wallet,
        name: messages.wallet,
        sortable: true,
        sortOrder: sort[ColumnId.Wallet],
        // width: 70,
        cellComponent: (props) => {
            const countryCode = getCountryCodeByCurrency(props.item.accountCurrency);

            const Flag = getCountryFlagByCountryCode(countryCode);

            return (
                <Table.Cell {...props}>
                    <Grid
                        alignItems='center'
                        columnGap={4}
                        gridTemplateColumns={Flag ? 'max-content max-content' : 'max-content'}
                    >
                        {Flag && <Flag width={22} />}

                        {props.item.accountCurrency}
                    </Grid>
                </Table.Cell>
            );
        },
    },
    {
        id: ColumnId.CreatedDate,
        name: messages.createdDate,
        sortable: true,
        sortOrder: sort[ColumnId.CreatedDate],
        // width: 120,
        value: (item) => moment(item.createdAt).format('ll'),
    },
    {
        id: ColumnId.Type,
        name: messages.type,
        sortable: true,
        sortOrder: sort[ColumnId.Type],
        // width: 100,
        value: (item) => getTransactionTypeText(item.type),
    },
    {
        id: ColumnId.Status,
        name: messages.status,
        sortable: true,
        sortOrder: sort[ColumnId.Status],
        // width: 100,
        cellComponent: (props) => {
            return (
                <Table.Cell {...props}>
                    <TransactionStatusTag status={props.item.status} />
                </Table.Cell>
            );
        },
    },
    {
        id: ColumnId.Amount,
        name: messages.amount,
        sortable: true,
        sortOrder: sort[ColumnId.Amount],
        headerTextAlign: 'right',
        textAlign: 'right',
        // width: 180,
        value: (item) => {
            return intl.formatCurrency(item.accountAmount, item.accountCurrency);
        },
        cellComponent: (props) => {
            const isIncoming = props.item.kind === TransactionKind.incoming;

            return (
                <Table.Cell {...props}>
                    <Text
                        color={isIncoming ? 'green100' : 'midnight100'}
                        font='label'
                        fontSize='small'
                        fontWeight={isIncoming ? 'medium' : 'regular'}
                    >
                        {isIncoming ? `+${props.value}` : props.value}
                    </Text>
                </Table.Cell>
            );
        },
    },
];
